import { render, staticRenderFns } from "./ChangeOrdersDriver.vue?vue&type=template&id=254a847c"
import script from "./ChangeOrdersDriver.vue?vue&type=script&lang=js"
export * from "./ChangeOrdersDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports